import { render } from "./FeaturedImage.vue?vue&type=template&id=33b5696a"
import script from "./FeaturedImage.vue?vue&type=script&lang=js"
export * from "./FeaturedImage.vue?vue&type=script&lang=js"

import "./FeaturedImage.vue?vue&type=style&index=0&id=33b5696a&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__